import api from './index';
import { ENDPOINTS } from './endpoints';

export const getEligibleGiftAccessories = (maxFreeValue) =>
    api.get(ENDPOINTS.FREE_GIFT.ELIGIBLE, { params: { maxFreeValue } });

export const selectFreeGift = (variantId) =>
    api.post(ENDPOINTS.FREE_GIFT.SELECT, { variantId });

export const removeFreeGift = (variantId) =>
    api.delete(ENDPOINTS.FREE_GIFT.REMOVE(variantId));
